import { render } from "./PublishClothes.vue?vue&type=template&id=9449fa78&scoped=true"
import script from "./PublishClothes.vue?vue&type=script&lang=js"
export * from "./PublishClothes.vue?vue&type=script&lang=js"

import "./PublishClothes.vue?vue&type=style&index=0&id=9449fa78&scoped=true&lang=less"
import "./PublishClothes.vue?vue&type=style&index=1&id=9449fa78&lang=css"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9449fa78"]])

export default __exports__